var _circle, _line, _circle2, _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 258,
    viewBox: "0 0 370 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.622,
    cy: 101.623,
    r: 48.0354,
    transform: "rotate(0.749822 189.622 101.623)",
    fill: "#F9F9F9",
    stroke: "#C4DAFF",
    strokeWidth: 9.00663
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 188.437,
    y1: 193.18,
    x2: 189.026,
    y2: 148.151,
    stroke: "#C4DAFF",
    strokeWidth: 15.0111
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.583,
    cy: 101.917,
    r: 17.5,
    fill: "#0999EB",
    stroke: "#D3EEFF",
    strokeWidth: 5.83334
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.476 105.905C187.476 104.642 187.632 103.635 187.946 102.885C188.259 102.135 188.876 101.314 189.797 100.422C190.727 99.5197 191.316 98.8788 191.563 98.499C191.943 97.9199 192.133 97.2932 192.133 96.6191C192.133 95.7267 191.909 95.0478 191.463 94.5826C191.026 94.1079 190.381 93.8705 189.526 93.8705C188.71 93.8705 188.05 94.1031 187.547 94.5683C187.053 95.0241 186.806 95.646 186.806 96.434H183.346C183.365 94.7535 183.934 93.4243 185.055 92.4464C186.184 91.4684 187.675 90.9795 189.526 90.9795C191.435 90.9795 192.921 91.4637 193.984 92.4321C195.057 93.4005 195.593 94.7535 195.593 96.491C195.593 98.0385 194.872 99.5624 193.429 101.062L191.677 102.786C191.05 103.498 190.727 104.537 190.708 105.905H187.476ZM187.233 110.334C187.233 109.774 187.409 109.323 187.76 108.981C188.112 108.63 188.586 108.454 189.185 108.454C189.792 108.454 190.272 108.634 190.623 108.995C190.974 109.346 191.15 109.793 191.15 110.334C191.15 110.856 190.979 111.293 190.637 111.644C190.295 111.995 189.811 112.171 189.185 112.171C188.558 112.171 188.074 111.995 187.732 111.644C187.4 111.293 187.233 110.856 187.233 110.334Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.025 134.23V98.13C77.025 95.9133 77.0883 93.5383 77.215 91.005C77.405 88.4083 77.6583 85.7167 77.975 82.93L41.4 134.23H77.025ZM116.925 134.23V150.76C116.925 152.217 116.418 153.483 115.405 154.56C114.455 155.637 113.062 156.175 111.225 156.175H102.675V188H77.025V156.175H21.355C19.5183 156.175 17.84 155.605 16.32 154.465C14.8633 153.325 13.945 151.9 13.565 150.19L10.525 135.655L74.555 49.585H102.675V134.23H116.925ZM319.164 134.23V98.13C319.164 95.9133 319.227 93.5383 319.354 91.005C319.544 88.4083 319.797 85.7167 320.114 82.93L283.539 134.23H319.164ZM359.064 134.23V150.76C359.064 152.217 358.557 153.483 357.544 154.56C356.594 155.637 355.2 156.175 353.364 156.175H344.814V188H319.164V156.175H263.494C261.657 156.175 259.979 155.605 258.459 154.465C257.002 153.325 256.084 151.9 255.704 150.19L252.664 135.655L316.694 49.585H344.814V134.23H359.064Z",
    fill: "#6EE385",
    fillOpacity: 0.53
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.525391,
    y: 49.585,
    width: 368.539,
    height: 208.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.431373 0 0 0 0 0.890196 0 0 0 0 0.521569 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.47413d655e954a0cde7cd6701f4c1c87.svg";
export { ForwardRef as ReactComponent };